import React, {useRef, useState} from 'react';
import * as Yup from "yup";
import {connect, useSelector} from "react-redux";
import Switch from "react-bootstrap-switch";
import { Card, CardBody, CardTitle, Col, Form, FormGroup, Input, Label, Row } from 'reactstrap';
import {ErrorMessage, useForm} from "react-hook-form";

import {
    GenericTableButton
} from "../../../components/buttons/buttonsActions";
import {
    INTERNATIONAL,
    MAX_NAME,
    REQUIRED
} from "../../../components/i18n/i18n";
import { MAX_NAME_SIZE } from "../../../components/menu-flower/constants";
import {
    FL_CODE,
    FL_IMAGE,
    FL_NAME,
} from "../../../components/i18n/formLabels";
import {PH_CODE, PH_IMAGE, PH_NAME} from "../../../components/i18n/placeHolders";
import {TT_CLOSE, TT_HISTORY, TT_SAVE} from "../../../components/i18n/toolTips";
import {LogHistoryModal} from "../../../components/logHistory/logHistoryModal";
import {getStateByPath} from "../../../redux/selectors";
import {genericIndexedActions} from "../../../redux/actions/generics/GenericIndexedActions";
import {GenericButton} from "../../../components/buttons/customButtons";
import Separator from "../../../components/Separator";
import {addonService} from "../../../jwt/_services/configuration/addonService";
import AddonLangs from "./_langs";
import PromotionControllerLangs from "../../promotions/promotionController/_langs";
import AddonPriceSection from "./AddonPriceSection";

const AddonForm = props => {
    const componentState = useSelector(state => getStateByPath(state, props.path));
    const { path } = componentState;
    const { app, editMode, domainObject} = componentState?.data;

    const [status, setStatus] = useState(domainObject?.status || true);

    const [langs, setlangs] = useState(domainObject?.langs || []);
    const translatableLangs = domainObject?.translatedLangs || []

    const [showModal, setShowModal] = useState(true)
    const modalRef = useRef(null);

    const showHistory = () => {
        setShowModal(true);
        modalRef.current.showModal(domainObject);
    }

    const validationSchema = Yup.object().shape({
        code: Yup.string().required(REQUIRED).max(MAX_NAME_SIZE, MAX_NAME),
    });

    const {register, handleSubmit, reset, errors} = useForm({
        validationSchema: validationSchema,
        defaultValues: {
            id: domainObject?.id,
            uid: domainObject?.uid,

            code: domainObject?.code,
            name: domainObject?.name,
            image: domainObject?.image
        }
    });

    const onSubmit = (data, _) => {
        const dataRequest = {
            fbDataBase: { id : app?.fbDataBase?.id },
            item : {
                ...data,
                id: domainObject?.id,
                status: status,
                langs: langs,
            }
        };

        if (!editMode)
            genericIndexedActions.save(path, addonService, dataRequest)
        else {
            let id = domainObject.id;
            dataRequest.item.id = id

            genericIndexedActions.update(path, addonService, id, dataRequest)
        }

        closeForm()
    };

    const closeForm = () => {
        reset();
        props.onClose()
    }

    return  <>
        <Form onSubmit={ handleSubmit(onSubmit) }>
            <Card className={'card-modal-medium'}>
                <CardTitle className="bg-light border-bottom p-3 mb-0">
                    <>
                        <h2 className={'card-modal-title'} > { (domainObject?.title || domainObject?.name || '') }</h2>
                        <br />
                        <h5 className={'card-modal-uid'} > { 'uid: ' + (domainObject?.uid || '') }</h5>
                    </>
                    <div className={'top-right'}>
                        <GenericButton
                            style={'table'}
                            icon={'fa-save'}
                            toolTip={TT_SAVE}
                            permission={'add'}
                            type={'submit'}
                        />
                        {
                            editMode && <>
                                <GenericTableButton
                                    toolTip={TT_HISTORY}
                                    icon={'fa-clock'}
                                    permission={'search'}
                                    onClick={showHistory}
                                />
                            </>
                        }
                        <Separator/>
                        <GenericButton
                            style={'danger-secondary'}
                            toolTip={TT_CLOSE}
                            icon={'fa-times'}
                            permission={'search'}
                            onClick={closeForm}
                        />
                    </div>
                </CardTitle>
                <CardBody className={'card-body-modal'}>
                    <Row>
                        <Col md={"6"}>
                            <Row>
                                <Col md="3">
                                    <FormGroup>
                                        <Label>{FL_CODE}</Label>
                                        <Input type="text" name="code"
                                               placeholder={PH_CODE}
                                               innerRef={register}
                                               className={(errors.code ? ' is-invalid' : '')}
                                        />
                                        <ErrorMessage errors={errors} name="code" component="div" className="invalid-feedback"/>
                                    </FormGroup>
                                </Col>
                                <Col md="3">
                                    <FormGroup>
                                        <Label>{FL_NAME}</Label>
                                        <Input type="text"
                                               name="name"
                                               placeholder={PH_NAME}
                                               innerRef={register}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md="3">
                                    <FormGroup>
                                        <Label>{FL_IMAGE}</Label>
                                        <Input type="text"
                                               name="image"
                                               placeholder={PH_IMAGE}
                                               innerRef={register}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md="2">
                                    <FormGroup>
                                        <Label>{'Activo'}</Label>
                                        <br/>
                                        <Switch animate={true} offText={"No"} onText={"Si"}
                                                value={status}
                                                onChange={_ => setStatus(!status)}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <div className={'form-container'}>
                                <div className={''}>
                                    <h2>{INTERNATIONAL}</h2>
                                </div>
                                <div className={''}>
                                    <AddonLangs
                                        langs={langs}
                                        setLangs={setlangs}
                                        translatableLangs={translatableLangs}
                                    />
                                </div>
                            </div>
                        </Col>
                        <Col md={"6"}>
                            <div className={'form-container'}>
                                <div className={''}>
                                    <h2>{'Precios'}</h2>
                                </div>
                                <div className={''}>
                                    {editMode && <AddonPriceSection path={path}/>}
                                </div>
                            </div>
                        </Col>
                    </Row>


                </CardBody>
            </Card>
        </Form>
        {
            showModal && <LogHistoryModal
                ref={modalRef}
                item={domainObject}
            />
        }
    </>
}

const mapStateToProps = _ => ({})

const mapActionsToProps = ({})

export default connect(mapStateToProps, mapActionsToProps)(AddonForm)